import request from '@/utils/request'
const url = '/SysUser'

export function login(UserName, Password) {
  return request({
    url: `${url}/Login`,
    method: 'post',
    data: {
      UserName,
      Password
    }
  })
}
export function getInfo() {
  return request({
    url: `${url}/DetailsByKey`,
    method: 'POST'
  })
}

export function logout(token) {
  return request({
    url: `${url}/LoginOut`,
    method: 'post',
    data: {
      Key: token
    }
  })
}

export function getMenu(Key) {
  return request({
    url: `${url}/UserMenu`,
    method: 'post',
    data: {
      Key: Key,
      IsManage: false
    }
  })
}

export function GetWeixInfo(params) {
  return request({
    url: `/BizMemberMember/WeixinUserInfo`,
    method: 'post',
    data: params
  })
}

export function WeixinLogin(OpenId) {
  return request({
    url: `${url}/WeixinLogin`,
    method: 'post',
    data: {
      OpenId: OpenId
    }
  })
}

export function Binding(params) {
  return request({
    url: `${url}/Binding`,
    method: 'post',
    data: params
  })
}
